import React from 'react';

import { ACADEMIC_TYPE } from '@common/type/CourseTypes';
import { Box } from '@mui/material';

import PurchaseButton from '../purchaseButton';
import PurchaseRemark from '../purchaseRemark';

import { Ga4Item } from '@interfaces/googleTagManager';
import { CourseDetailEntity, AcademicCourseEnrollmentStatus } from '@redux/course/type/courseDetailType';

type PurchaseSectionType = {
  name: string;
  idName: string;
  price: CourseDetailEntity['price'];
  gtmContentId: string;
  enrollmentStatus: AcademicCourseEnrollmentStatus;
  examExpiredAt?: Date;
  courseDetailData: CourseDetailEntity;
};

const PurchaseAvailable = ({
  name,
  idName,
  price,
  gtmContentId,
  enrollmentStatus = AcademicCourseEnrollmentStatus.AVAILABLE_REGISTER,
  examExpiredAt,
  courseDetailData,
}: PurchaseSectionType) => {
  const isShowRemark = [
    AcademicCourseEnrollmentStatus.ACADEMIC_AUDIT_ENROLLED,
    AcademicCourseEnrollmentStatus.ACADEMIC_CREDIT_PASSED_REGRADE,
    AcademicCourseEnrollmentStatus.ACADEMIC_CREDIT_REGRADE,
    AcademicCourseEnrollmentStatus.ACADEMIC_CREDIT_ENROLLMENT_EXPIRED,
  ].includes(enrollmentStatus);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
      <Box sx={{ display: 'grid', gap: '16px', gridTemplateAreas: { xs: '"credit" "audit"', md: '"audit credit"' } }}>
        <PurchaseButton
          sx={{ gridArea: 'audit' }}
          name={name}
          idName={idName}
          enrollmentStatus={enrollmentStatus}
          price={price}
          gtmContentId={gtmContentId}
          courseDetailData={courseDetailData}
        />
        <PurchaseButton
          sx={{ gridArea: 'credit' }}
          name={name}
          idName={idName}
          enrollmentStatus={enrollmentStatus}
          purchaseType={ACADEMIC_TYPE.CREDIT}
          price={price}
          gtmContentId={gtmContentId}
          courseDetailData={courseDetailData}
        />
      </Box>
      {isShowRemark && <PurchaseRemark examExpiredAt={examExpiredAt} enrollmentStatus={enrollmentStatus} />}
    </Box>
  );
};

export default PurchaseAvailable;
